import { render } from "./EmailRequestFunds.vue?vue&type=template&id=86897772&scoped=true"
import script from "./EmailRequestFunds.vue?vue&type=script&lang=js"
export * from "./EmailRequestFunds.vue?vue&type=script&lang=js"

import "./EmailRequestFunds.vue?vue&type=style&index=0&id=86897772&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-86897772"]])

export default __exports__